import useGlobalSfx from 'root/lib/hooks/useGlobalSfx';
import Loader from 'a/hub/screens/Season3/Loader';
import { workshopSfx } from '../audio/audioMapAws';
import intro from '../audio/taps';

const useWorkshopSfx = () => {
  const { playAudio, ...globalSfx } = useGlobalSfx();
  const playTap = (isSoftTap = false) => {
    playAudio({
      src: intro[isSoftTap ? 'sfx_soft_tap' : 'sfx_tap'],
      interrupt: true,
      continuePlayingAfterUnmount: true,
    });
  };

  const playByName = (audioName, config) => {
    playAudio({ src: workshopSfx[audioName], ...config });
  };

  const playSfxFromMap = (audioValue, config = {}) => {
    const src = Loader.getLoadedAsset(audioValue);
    playAudio({ src, interrupt: true, ...config });
  };

  return { playTap, playByName, playSfxFromMap, audioMap: workshopSfx, playAudio, globalSfx };
};

export default useWorkshopSfx;
